// extracted by mini-css-extract-plugin
export default {"requisites":"S8ync"};